import { Rise, Section, SectionHeader } from "./primitives";

const STAGES = [
  {
    n: "01",
    name: "Foundation",
    sub: "Technical SEO + architecture",
    activities: [
      "Full crawl, indexation and rendering diff",
      "Core Web Vitals and template remediation",
      "Information architecture and internal linking",
    ],
    signal: "Indexable, fast, unambiguous pages",
  },
  {
    n: "02",
    name: "Visibility",
    sub: "Content + topical relevance",
    activities: [
      "Commercial-intent page rewrites",
      "Topical clusters built from real gaps",
      "Local service-area coverage where it applies",
    ],
    signal: "Non-brand impressions and clicks",
  },
  {
    n: "03",
    name: "Authority",
    sub: "Links + digital PR + brand signals",
    activities: [
      "Editorial placements on owned assets",
      "Industry and regional press relationships",
      "Review and reputation cadence",
    ],
    signal: "Referring domains on pages that rank",
  },
  {
    n: "04",
    name: "AI Search",
    sub: "Entities + answer engines + citation readiness",
    activities: [
      "Entity and schema graph work",
      "Answer-shaped content structure",
      "Citation monitoring across AI surfaces",
    ],
    signal: "Pages referenced in AI answers",
  },
];

/** Homepage-level methodology: four stages, no framework overload. */
export function HomeMethodologyV2() {
  return (
    <Section tone="raised" labelledBy="methodology-heading">
      <div className="container-page py-20 md:py-28">
        <SectionHeader
          id="methodology-heading"
          eyebrow="How growth compounds"
          title={<>Four stages, run in order.</>}
          intro="Skipping a stage is the most common reason search investment underperforms. Content cannot outrun a broken foundation, and authority cannot rescue a page nobody can parse."
        />

        <ol className="mt-14 grid gap-6 md:grid-cols-2 xl:grid-cols-4">
          {STAGES.map((s, i) => (
            <Rise as="li" key={s.n} delay={(i % 4) as 0 | 1 | 2 | 3}>
              <article className="flex h-full flex-col rounded-2xl border border-border bg-background p-6 transition-colors duration-300 hover:border-primary/45">
                <div className="flex items-baseline gap-3">
                  <span className="font-display text-3xl text-primary">{s.n}</span>
                  <h3 className="font-display text-xl leading-tight">{s.name}</h3>
                </div>
                <p className="mt-2 text-xs uppercase tracking-[0.16em] text-muted-foreground">
                  {s.sub}
                </p>
                <ul className="mt-5 space-y-2 text-sm text-muted-foreground">
                  {s.activities.map((a) => (
                    <li key={a} className="flex gap-2">
                      <span aria-hidden className="text-primary">
                        —
                      </span>
                      <span>{a}</span>
                    </li>
                  ))}
                </ul>
                <p className="mt-6 border-t border-border pt-4 text-xs text-foreground/80">
                  <span className="text-muted-foreground">What we watch: </span>
                  {s.signal}
                </p>
              </article>
            </Rise>
          ))}
        </ol>
      </div>
    </Section>
  );
}
